import { Injectable } from '@angular/core';
import moment from 'moment';
import { firstValueFrom } from 'rxjs';
import { FilterUserProduct, UserSedoristProductsGQL } from 'src/gql/generated';
import { MEMBER_PURCHASE_DAYS, type MemberPurchase, toMemberPurchases } from '../utils/member-purchase';

/** 商品共有（せどりすと）の仕入れ実績を、ヤマダ・エディオンの在庫一覧用に取る */
@Injectable({ providedIn: 'root' })
export class MemberPurchaseService {
  constructor(private sedoristGql: UserSedoristProductsGQL) {}

  /** 直近 days 日の実績のうち、仕入店舗が storeName のもの。見える範囲は商品共有の画面と同じ（自分のグループ） */
  async loadRecent(storeName: string, days = MEMBER_PURCHASE_DAYS): Promise<MemberPurchase[]> {
    const resp = await firstValueFrom(
      this.sedoristGql.fetch({
        variables: {
          fromDate: moment().subtract(days, 'days').format('YYYY-MM-DD'),
          toDate: moment().format('YYYY-MM-DD'), // 無いと buying_date <= NULL になって 1 件も返らない
          filterUserProduct: FilterUserProduct.All,
        },
      }),
    );
    const rows = (resp.data?.userSedoristProducts ?? []).map((r) => ({
      id: r.id,
      user: { name: r.user?.name ?? '' },
      amazonProduct: {
        asin: r.amazonProduct.asin,
        imageUrl: r.amazonProduct.imageUrl,
        salesCommission: r.amazonProduct.salesCommission,
        categoryFee: r.amazonProduct.categoryFee,
        fbaShippingFee: r.amazonProduct.fbaShippingFee,
        // 画面の下の一覧（在庫一覧と同じ形）で Amazon 価格と利益を出すため
        latestPrice: r.amazonProduct.latestPrice,
        lastKnownPrice: r.amazonProduct.lastKnownPrice
          ? { price: r.amazonProduct.lastKnownPrice.price, at: r.amazonProduct.lastKnownPrice.at }
          : null,
        keepaProduct: r.amazonProduct.keepaProduct
          ? {
              boughtPastMonth: r.amazonProduct.keepaProduct.boughtPastMonth,
              latestPrice: r.amazonProduct.keepaProduct.latestPrice,
              lastKnownPrice: r.amazonProduct.keepaProduct.lastKnownPrice
                ? {
                    price: r.amazonProduct.keepaProduct.lastKnownPrice.price,
                    at: r.amazonProduct.keepaProduct.lastKnownPrice.at,
                  }
                : null,
              keepaUpdatedAt: r.amazonProduct.keepaProduct.keepaUpdatedAt,
            }
          : null,
      },
      product: r.product ? { jan: r.product.jan } : null,
      productName: r.productName,
      buyingPrice: r.buyingPrice,
      sellingPrice: r.sellingPrice,
      buyingDate: r.buyingDate,
      buyingStore: r.buyingStore ? { name: r.buyingStore.name } : null,
    }));
    return toMemberPurchases(rows, storeName);
  }
}
